import dayjs, { Dayjs } from 'dayjs';
import { DateRange } from '@mui/x-date-pickers-pro';

export const getDateRangeInDays = ([startDate, endDate]: DateRange<Dayjs>): number => {
  const start = dayjs(startDate);
  const end = dayjs(endDate);
  return end.diff(start, 'day');
};

export const getKpiPercentageChange = (
  currentValue: number,
  priorValue: number,
  showFraction: boolean = false,
): string => {
  if (!priorValue) return '?%';

  const percentChange = Math.abs((priorValue - currentValue) / priorValue);

  return new Intl.NumberFormat('default', {
    style: 'percent',
    minimumFractionDigits: 0,
    maximumFractionDigits: showFraction ? 2 : 0,
  }).format(percentChange);
};

/**
 * Formats a range of two dates into a readable string.
 * @param {Array} dates - An array containing two moment.js date objects.
 * @returns {string} - A formatted date range string or a default message if dates are not set.
 */
export const  getFormatDateRange = (dates: DateRange<Dayjs>): string => {
  if (dates.length !== 2 || !dates[0] || !dates[1]) {
    return 'Date range not set';
  }
  return `${dates[0].format('MMM D, YYYY')} to ${dates[1].format('MMM D, YYYY')}`;
}

/**
 * 
 * @param value number
 * @returns number
 * @description Returns the default precision for a given value based on its magnitude.
 */
export const getDefaultPrecision = (value: number): number => {
  if (value >= 10_000_000 || (value >= 10_000 && value < 100_000)) {
    return 1;
  } else if (
    (value >= 1_000_000 && value < 10_000_000) ||
    (value >= 1_000 && value < 10_000)
  ) {
    return 2;
  } else if (value >= 100_000 && value < 1_000_000) {
    return 0;
  } else {
    return 3;
  }
};